import React from 'react';
import styled from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';

import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { Section, InnerSection } from '../../../styles/section/section';
import { sortArrayBasedonArrayOrder } from '../../../utils/sort-array-based-on-array-order';
import { useHomeContext } from '../context';
import { Topics } from '../../../helpers/topics';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

const BrowseTopicsInnerSection = styled(InnerSection)`
  padding-bottom: 1.975rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-bottom: 4rem;
  }
`;

export const BrowseTopics = () => {
  const data = useHomeContext();
  const topics = data?.allStrapiTopic?.edges.filter(
    (x) => x.node?.topic_name?.toLowerCase() !== 'misc'
  );
  const sortedTopicIds = data?.getSupportData?.topics;
  const tempSortedTopics = sortArrayBasedonArrayOrder(
    topics,
    sortedTopicIds,
    (x) => x.node.uid
  );
  const sortedTopics =
    tempSortedTopics && tempSortedTopics.length > 0
      ? tempSortedTopics?.slice(0, 7)
      : topics?.slice(0, 7);
  const [ref] = SendInViewEvent({
    isLoading: data?.isLoading,
    component_name: 'home_browse_topics',
    data: { topics, sortedTopicIds, sortedTopics }
  });

  return (
    <Section primary ref={ref}>
      <HeaderTextBlock size="responsive">
        <HeaderTextBlockTitle>Browse Topics</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <BrowseTopicsInnerSection>
        <Topics topics={sortedTopics} />
      </BrowseTopicsInnerSection>
    </Section>
  );
};
